
import SvgIcon from "@/components/common/SvgIcon.vue";
import Tabs from "@/components/Tabs.vue";
import {ref, watch, watchEffect} from "vue";
import {LinkType} from "@/utils/general.type";
import store from "@/store";
import i18n from "@/locales";
import {useI18n} from "vue-i18n";
import router from "@/router";
import {RouteRecordName} from "vue-router";

type FooterType = {
  title: string;
  content: LinkType[],
}

const host = window.location.host;
const protocol = window.location.protocol;

const _footerList: FooterType[] = [
  {
    title: "VIC",
    content: [
      {text: "VIC", link: "#", external: false},
      {text: "Beauty VIC", link: "#", external: false},
      {text: "Tourist VIC", link: "#", external: false},
    ],
  },
  {
    title: "About Times Square",
    content: [
      {text: "About Us", link: `${protocol}//${host}/about-us/`, external: true},
      {text: "Access And Hour", link: `${protocol}//${host}/access-and-hour/`, external: true},
      {text: "Service And Facilities", link: `${protocol}//${host}/service-and-facilities/`, external: true},
      {text: "Contact Us", link: `${protocol}//${host}/contact-us/`, external: true},
      // {text: "Join Us", link: "#join", external: true},
      {text: "Floor Plan", link: `${protocol}//${host}/floor-plan/`, external: true},
    ],
  },
  {
    title: "Download Our App",
    content: [
      {icon: "app-store", link: "https://apps.apple.com/pk/app/hong-kong-times-square/id859941365", external: true},
      {icon: "play-store", link: "https://play.google.com/store/apps/details?id=com.timessquare&hl=en", external: true},
    ],
  },
];

const aboutLocales = ["about-us", "access", "service", "contact-us", "floor-plan"];

const langList = ['ENG', '繁', '简'];
const langLocale = ['en', 'zh', 'sc'];

export default {
  name: "Footer",
  components: {Tabs, SvgIcon},
  setup() {
    const lang = ref(
        Math.max(langLocale.findIndex(l => l === i18n.global.locale), 0)
    );
    const footerList = ref(_footerList);
    const {t} = useI18n();

    const onLinkClicked = (link: LinkType) => {
      if (link.external) return;
      if (link.text && link.text.endsWith("VIC")) {
        const type = link.text.startsWith("B") ? 1 :
            (link.text.startsWith("T") ? 2 : 0);
        store.commit('onTypeChange', type);
        // console.log("hello");
      }
    }
    watch(lang, (val) => {
      console.log(router.currentRoute.value.name);
      router.push({
        name: router.currentRoute.value.name as RouteRecordName,
        params: {
          lang: langLocale[val]
        }
      })
      // i18n.global.locale =
    })

    watchEffect(() => {
      const mLang = i18n.global.locale;
      lang.value = Math.max(langLocale.findIndex(l => l === mLang), 0);
      footerList.value[1].title = t('about-ts');
      footerList.value[2].title = t('download-app');
      aboutLocales.forEach((item: string, index: number) => {
        footerList.value[1].content[index].text = t(item);
      })
    })

    return {
      langList,
      lang,
      footerList,
      onLinkClicked
    }
  }
}
